// extracted by mini-css-extract-plugin
module.exports = {"semitransparent":"Buttons_semitransparent__2rpwB","emptyButton":"Buttons_emptyButton__2VChz"};